import httpClient from '../../services/HttpClient';

export const usePricingHook = () => {
  // FAST LANE

  const getFastLaneRules = async (dataObject) => {
    try {
      const { page, orderDirection, searchBy, orderBy, filterBy, limit } = dataObject;
      const orderByInfo = orderDirection ? `&orderBy=${orderBy}&order=${orderDirection}` : '';
      const searchByInfo = searchBy ? `&search=${searchBy}` : '';
      const filter = filterBy ? `&filter=${filterBy}` : '';
      const pageNum = page || 1;
      const limitInfo = limit ? `&limit=${limit}` : '';

      const { data, pagination } = await httpClient({
        method: 'GET',
        url: `/flane?page=${pageNum}${limitInfo}${orderByInfo}${searchByInfo}${filter}`
      });
      return { data, pagination };
    } catch (err) {
      return { err };
    }
  };

  const getFastLaneEditRules = async (id) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/flane/${id}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const getCompanyList = async (productName) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/company/list?productName=${productName}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const getFastLaneRulesList = async (idCompany) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/flane/list?company=${idCompany}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const createFastLaneRule = async (dataObject) => {
    try {
      const { data } = await httpClient({
        method: 'POST',
        url: '/flane',
        data: dataObject
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const updateFastLaneRule = async ({ id, ...others }) => {
    try {
      const { data } = await httpClient({
        method: 'PUT',
        url: `/flane/${id}`,
        data: others
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const deleteFastLaneRule = async ({ id }) => {
    try {
      const { data } = await httpClient({
        method: 'DELETE',
        url: `/flane/${id}`,
        data: {}
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const changeFLRuleActiveStatus = async ({ id }) => {
    try {
      const { status } = await httpClient({
        method: 'PATCH',
        url: `/flane/${id}/status`,
        data: {}
      });
      return { status };
    } catch (err) {
      return { err };
    }
  };

  // PAYPHONE

  const getPayPhoneRules = async (dataObject) => {
    try {
      const { page, orderDirection, orderBy, searchBy, filterBy, limit } = dataObject;
      const orderByInfo = orderDirection ? `&orderBy=${orderBy}&order=${orderDirection}` : '';
      const searchByInfo = searchBy ? `&search=${searchBy}` : '';
      const filter = filterBy ? `&filter=${filterBy}` : '';
      const pageNum = page || 1;
      const limitInfo = limit ? `&limit=${limit}` : '';

      const { data, pagination } = await httpClient({
        method: 'GET',
        url: `/cpass?page=${pageNum}${limitInfo}${orderByInfo}${searchByInfo}${filter}`
      });
      return { data, pagination };
    } catch (err) {
      return { err };
    }
  };

  const getPayPhoneRulesList = async (idCompany) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/cpass/list?company=${idCompany}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const createPayPhoneRule = async (dataObject) => {
    try {
      const { data } = await httpClient({
        method: 'POST',
        url: '/cpass',
        data: dataObject
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const updatePayPhoneRule = async ({ id, ...others }) => {
    try {
      const { price, payphoneStagesPricing, ...rest } = others;
      if (others.pricingType == 1) {
        others = { ...rest, price, payphoneStagesPricing: [] };
      } else if (others.pricingType == 2) {
        others = { ...rest, payphoneStagesPricing, price: 0 };
      }
      const { data } = await httpClient({
        method: 'PUT',
        url: `/cpass/${id}`,
        data: others
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const changePPRuleActiveStatus = async ({ id }) => {
    try {
      const { status } = await httpClient({
        method: 'PATCH',
        url: `/cpass/${id}/status`,
        data: {}
      });
      return { status };
    } catch (err) {
      return { err };
    }
  };

  // Vipp

  const getVipoRegions = async () => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/regions`
      });
      return { data };
    } catch (error) {
      return { error };
    }
  };

  const getVipoRegionsCountries = async (id) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/regions/${id}/countries`
      });
      return { data };
    } catch (error) {
      return { error };
    }
  };

  const getVipoRegionsCountriesTelecoms = async (regionId, countryId) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/regions/${regionId}/countries/${countryId}/telecoms`
      });
      return { data };
    } catch (error) {
      return { error };
    }
  };

  const getVippRules = async (dataObject) => {
    try {
      const { page, orderDirection, searchBy, filterBy, limit, orderBy } = dataObject;
      const orderByInfo = orderDirection ? `&orderBy=${orderBy}&order=${orderDirection}` : '';
      const searchByInfo = searchBy ? `&search=${searchBy}` : '';
      const filter = filterBy ? `&filter=${filterBy}` : '';
      const pageNum = page || 1;
      const limitInfo = limit ? `&limit=${limit}` : '';

      const { data, pagination } = await httpClient({
        method: 'GET',
        url: `/vipp?includeVipo=true&page=${pageNum}${limitInfo}${orderByInfo}${searchByInfo}${filter}`
      });
      return { data, pagination };
    } catch (err) {
      return { err };
    }
  };

  const getVippRuleById = async (id) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/vipp/${id}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const getVipoRuleById = async (id) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/vipo/${id}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const createVippRule = async (dataObject) => {
    try {
      const { data } = await httpClient({
        method: 'POST',
        url: '/vipp',
        data: dataObject
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const createVipoRule = async (dataObject) => {
    try {
      const { data } = await httpClient({
        method: 'POST',
        url: '/vipo',
        data: dataObject
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const updateVipoRule = async ({ id, ...others }) => {
    try {
      if (others.connectionType == '2') {
        others = { ...others, trunk: undefined };
      } else {
        others = { ...others, ANI: undefined };
      }
      const { data } = await httpClient({
        method: 'PUT',
        url: `/vipo/${id}`,
        data: others
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };
  const updateVippRule = async ({ id, ...others }) => {
    try {
      const { price, vippStagesPricing, ...rest } = others;
      if (others.pricingType == 4) {
        others = { ...rest, price, vippStagesPricing: [] };
      } else if (others.pricingType == 3) {
        others = { ...rest, vippStagesPricing, price: 0 };
      }
      const { data } = await httpClient({
        method: 'PUT',
        url: `/vipp/${id}`,
        data: others
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const deleteVippRule = async ({ id }) => {
    try {
      const { data } = await httpClient({
        method: 'DELETE',
        url: `/vipp/${id}`,
        data: {}
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const getVippRulesList = async (idCompany) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/vipp/list?company=${idCompany}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const changeVippRuleActiveStatus = async ({ id }) => {
    try {
      const { status } = await httpClient({
        method: 'PATCH',
        url: `/vipp/${id}/status`,
        data: {}
      });
      return { status };
    } catch (err) {
      return { err };
    }
  };

  const changeVipoRuleActiveStatus = async ({ id }) => {
    try {
      const { status } = await httpClient({
        method: 'PATCH',
        url: `/vipo/${id}/status`,
        data: {}
      });
      return { status };
    } catch (err) {
      return { err };
    }
  };

  // Ventana

  const getVtnaRules = async (dataObject) => {
    try {
      const { page, orderDirection, searchBy, filterBy, limit, orderBy } = dataObject;
      const orderByInfo = orderDirection ? `&orderBy=${orderBy}&order=${orderDirection}` : '';
      const searchByInfo = searchBy ? `&search=${searchBy}` : '';
      const filter = filterBy ? `&filter=${filterBy}` : '';
      const pageNum = page || 1;
      const limitInfo = limit ? `&limit=${limit}` : '';

      const { data, pagination } = await httpClient({
        method: 'GET',
        url: `/vnta?page=${pageNum}${limitInfo}${orderByInfo}${searchByInfo}${filter}`
      });
      return { data, pagination };
    } catch (err) {
      return { err };
    }
  };

  const getVtnaEditRules = async (id) => {
    try {
      const { data, pagination } = await httpClient({
        method: 'GET',
        url: `/vnta/${id}`
      });
      return { data, pagination };
    } catch (err) {
      return { err };
    }
  };
  const createVtnaRule = async (dataObject) => {
    try {
      const { data } = await httpClient({
        method: 'POST',
        url: '/vnta',
        data: dataObject
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const updateVtnaRule = async ({ id, ...others }) => {
    try {
      const { data } = await httpClient({
        method: 'PUT',
        url: `/vnta/${id}`,
        data: others
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const deleteVtnaRule = async ({ id }) => {
    try {
      const { data } = await httpClient({
        method: 'DELETE',
        url: `/vnta/${id}`,
        data: {}
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const getVtnaRulesList = async (idCompany) => {
    try {
      const { data } = await httpClient({
        method: 'GET',
        url: `/vnta/list?company=${idCompany}`
      });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const changeVtnaRuleActiveStatus = async ({ id }) => {
    try {
      const { status } = await httpClient({
        method: 'PATCH',
        url: `/vnta/${id}/status`
      });
      return { status };
    } catch (err) {
      return { err };
    }
  };

  const getProductHubStats = async ({
    companyId,
    productCode,
    effectiveDateFrom,
    effectiveDateTo
  }) => {
    try {
      let url = `/client-product-pricing/dashboard?companyId=${companyId}&productCode=${productCode}`;
      if (effectiveDateFrom) url += `&effectiveDateFrom=${effectiveDateFrom}`;
      if (effectiveDateTo) url += `&effectiveDateTo=${effectiveDateTo}`;
      const { data } = await httpClient({ method: 'GET', url });
      return { data };
    } catch (err) {
      return { err };
    }
  };

  const methodCall = (method, id = null, dataObject = {}) => {
    const calls = {
      getCompanyList,

      getFastLaneRules,
      getFastLaneEditRules,
      createFastLaneRule,
      deleteFastLaneRule,
      updateFastLaneRule,
      changeFLRuleActiveStatus,
      getPayPhoneRules,
      createPayPhoneRule,
      updatePayPhoneRule,
      changePPRuleActiveStatus,
      getFastLaneRulesList,
      getPayPhoneRulesList,

      getVippRules,
      getVippRuleById,
      getVipoRuleById,
      getVippRulesList,
      createVippRule,
      deleteVippRule,
      updateVippRule,
      updateVipoRule,
      changeVippRuleActiveStatus,
      changeVipoRuleActiveStatus,

      createVipoRule,
      getVipoRegions,
      getVipoRegionsCountries,
      getVipoRegionsCountriesTelecoms,

      getVtnaRules,
      getVtnaEditRules,
      getVtnaRulesList,
      createVtnaRule,
      deleteVtnaRule,
      updateVtnaRule,
      changeVtnaRuleActiveStatus,

      getProductHubStats
    };

    return (calls[method] || calls['get'])(id, dataObject);
  };

  return { methodCall };
};
